<header fxLayoutAlign="center center" fxLayoutAlign.gt-xs="start center">
    <img class="height-5" app-logo>
</header>
